module.exports = __webpack_public_path__ + "static/4-476967c54fe31d7c0e44d403c8e27573.jpg";